const smile = {
    awful: '😩',
    bad: '🙁',
    ok: '😐',
    good: '🙂',
    excellent: '😃',
}

export const emoji = {
    clock: '\uD83D\uDD51',
    rocket: '\uD83D\uDE80',
    confetti: '🎉',
    bagOfMoney: '\uD83D\uDCB0',
    success: '✅',
    smile,
}
